import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function BlogCard({ post }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const cleanPath = currentPath.endsWith("/")
    ? currentPath.slice(0, -1)
    : currentPath;
  const newPath =
    cleanPath.substring(0, cleanPath.lastIndexOf("/")) + "/" + post.slug;

  return (
    <Link
      to={newPath}
      className="w-full md:w-[calc(33.333%-16px)] flex-none flex flex-col bg-white border border-gray-100 rounded-[20px] p-4 shadow-[0_4px_20px_rgba(0,0,0,0.04)] group cursor-pointer transition-all hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] snap-start"
    >
      <div className="rounded-xl overflow-hidden mb-4 aspect-[4/3]">
        <img
          src={post.mainImage}
          alt={post.title}
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      <div className="flex items-start justify-between gap-3 mb-2">
        <h3 className="font-bold text-[18px] text-gray-900 leading-snug group-hover:text-[#FF552E] transition-colors pr-2">
          {post.title}
        </h3>
        <ArrowUpRight
          className="text-gray-900 flex-shrink-0 mt-0.5"
          size={20}
          strokeWidth={1.5}
        />
      </div>

      <p className="text-gray-500 text-[14px] mb-6 line-clamp-3 flex-grow h-[60px] md:h-[80px]">
        {post.intro}
      </p>

      <div className="flex gap-2 flex-wrap mt-auto pt-1">
        {post.tags &&
          post.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-[#FF552E] text-[10px] md:text-[13px] font-medium border border-[#FF552E] rounded-lg px-3 py-1"
            >
              {tag}
            </span>
          ))}
      </div>
    </Link>
  );
}
